import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted, onUnmounted, watch, nextTick } from 'vue';
  import { isAiPricingFeatureEnabled, user } from '@/ui/auth/auth';
  import ContactUsModal from '@/ui/pages/subscription/Chargebee/details/ContactUsModal.vue';
  import { Icon } from '@/ui/components/icon/Icon';
  import { useModal } from '@/ui/concerns/modals/useModal';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AiCreditsBanner',
  setup(__props) {

  const DISMISSED_100_KEY = 'ai-credits-banner-dismissed-100';
  const DISMISSED_80_99_KEY = 'ai-credits-banner-dismissed-80-99';

  const [showContactUsModal, onContactUsClick, onContactUsClose] = useModal();
  const bannerRef = ref<HTMLElement | null>(null);

  const creditPercentage = computed(() => {
    const monthly = user.value.aiWallet?.monthly || 0;
    const available = user.value.aiWallet?.available || 0;
    const used = monthly - available;
    if (!monthly) {
      return 0;
    }

    return Math.round((used / monthly) * 100);
  });

  const localStorageTrigger = ref(0);
  const forceUpdate = () => {
    localStorageTrigger.value++;
  };

  const showBanner = computed(() => {
    // Force reactivity check: ensure showBanner updates when localStorageTrigger changes
    localStorageTrigger.value;

    const percentage = creditPercentage.value;
    const isDismissedAt100 = localStorage.getItem(DISMISSED_100_KEY) === 'true';
    const isDismissedAt80to99 = localStorage.getItem(DISMISSED_80_99_KEY) === 'true';

    if (percentage >= 100) {
      return !isDismissedAt100;
    }

    if (percentage >= 80) {
      return !isDismissedAt80to99;
    }

    return false;
  });

  const onDismissClick = () => {
    const percentage = creditPercentage.value;

    if (percentage >= 100) {
      localStorage.setItem(DISMISSED_100_KEY, 'true');
    } else {
      localStorage.setItem(DISMISSED_80_99_KEY, 'true');
    }

    forceUpdate();
  };

  const cleanupLocalStorage = () => {
    const percentage = creditPercentage.value;

    if (percentage < 80) {
      localStorage.removeItem(DISMISSED_80_99_KEY);
    }
    if (percentage < 100) {
      localStorage.removeItem(DISMISSED_100_KEY);
    }
  };

  cleanupLocalStorage();

  const updateBannerHeight = () => {
    nextTick(() => {
      if (bannerRef.value && showBanner.value) {
        const height = bannerRef.value.offsetHeight;
        const heightInRem = height / 16; // Convert px to rem (assuming 16px base font size)
        document.documentElement.style.setProperty('--ai-credits-banner-height', `${heightInRem}rem`);
      } else {
        document.documentElement.style.setProperty('--ai-credits-banner-height', '0rem');
      }
    });
  };

  watch(showBanner, () => {
    updateBannerHeight();
  });

  onMounted(() => {
    updateBannerHeight();
    window.addEventListener('resize', updateBannerHeight);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateBannerHeight);
    document.documentElement.style.setProperty('--ai-credits-banner-height', '0rem');
  });

return { __sfc: true,DISMISSED_100_KEY, DISMISSED_80_99_KEY, showContactUsModal, onContactUsClick, onContactUsClose, bannerRef, creditPercentage, localStorageTrigger, forceUpdate, showBanner, onDismissClick, cleanupLocalStorage, updateBannerHeight, isAiPricingFeatureEnabled, ContactUsModal, Icon }
}

})